import React from 'react';

export function TimingIcon(): JSX.Element {
  return (
    <svg fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
      <rect fill='#FEEADA' height='24' rx='6' width='24' />
      <g clipPath='url(#clip0_10119_61811)'>
        <path
          clipRule='evenodd'
          d='M12 6.21429C8.80464 6.21429 6.21429 8.80464 6.21429 12C6.21429 15.1954 8.80464 17.7857 12 17.7857C15.1954 17.7857 17.7857 15.1954 17.7857 12C17.7857 8.80464 15.1954 6.21429 12 6.21429ZM5.25 12C5.25 8.27208 8.27208 5.25 12 5.25C15.7279 5.25 18.75 8.27208 18.75 12C18.75 15.7279 15.7279 18.75 12 18.75C8.27208 18.75 5.25 15.7279 5.25 12ZM12 9.10714C12.2663 9.10714 12.4821 9.32301 12.4821 9.58929V11.8215L14.8152 14.5403C14.9886 14.7424 14.9653 15.0468 14.7633 15.2202C14.5612 15.3936 14.2568 15.3703 14.0834 15.1683L11.6341 12.314C11.5591 12.2266 11.5179 12.1152 11.5179 12V9.58929C11.5179 9.32301 11.7337 9.10714 12 9.10714Z'
          fill='#F59F64'
          fillRule='evenodd'
        />
      </g>
      <defs>
        <clipPath id='clip0_10119_61811'>
          <rect fill='white' height='13.5' transform='translate(5.25 5.25)' width='13.5' />
        </clipPath>
      </defs>
    </svg>
  );
}
